import { render, staticRenderFns } from "./phone-field.vue?vue&type=template&id=050e9d14&scoped=true&lang=pug"
import script from "./phone-field.vue?vue&type=script&lang=js"
export * from "./phone-field.vue?vue&type=script&lang=js"
import style0 from "./phone-field.vue?vue&type=style&index=0&id=050e9d14&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e9d14",
  null
  
)

export default component.exports